module.exports = __webpack_public_path__ + "img/double-arrow-down.384b6176.svg";